import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import {
  Box,
  Checkbox,
  FormControlLabel,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import UserAllAddressDialog from "../../components/allAddressDialog";
import GlobalButton from "../../components/button";
import InputField from "../../components/InputField";
import Label from "../../components/label";
import CustomSelect from "../../components/select";
import RomanianCities from "../../json/romaniaCities.json";
import AddEditAddressDialog from "../user/addressBook/AddEditAddressDialog";
import { t } from "i18next";

const ShippingInfo = ({ isAcceptPolicy, setisAcceptPolicy }) => {
  const openAddressDialog = useRef(null);
  const openAddEditAddressDialog = useRef(null);
  const userAddress = useSelector(
    (state) => state.userAddressReducer.userAddress
  );

  const [inputValues, setInputValues] = useState({
    fname: "",
    lname: "",
    email: "",
    contact: "",
    state: "",
    city: "",
    country: "Romania",
    zipCode: "",
    address: "",
  });

  const [inputError, setInputError] = useState({
    fname: false,
    lname: false,
    email: false,
    isValidEmail: false,
    contact: false,
    state: false,
    city: false,
    zipCode: false,
    address: false,
  });

  useEffect(() => {
    if (userAddress) {
      setInputValues({
        fname: userAddress?.firstname || "",
        lname: userAddress?.lastname || "",
        email: userAddress?.email || "",
        contact: userAddress?.contact || "",
        state: userAddress?.state || "",
        city: userAddress?.city || "",
        country: "Romania",
        zipCode: userAddress?.zipCode || "",
        address: userAddress?.address || "",
      });
    }
  }, [userAddress]);

  const handleChangeInputs = (event) => {
    const { name, value } = event.target;

    setInputError((err) => ({
      ...err,
      [name]: false,
      isValidEmail: name === "email" ? false : inputError.isValidEmail,
    }));

    setInputValues((val) => ({ ...val, [name]: value }));
  };

  const handleStateChange = (event) => {
    const selectedState = event.target.value;
    setInputValues((val) => ({ ...val, state: selectedState, city: "" }));
  };

  const handleCityChange = (event) => {
    const selectedCity = event.target.value;
    setInputValues((val) => ({ ...val, city: selectedCity }));
  };

  return (
    <Box>
      <Typography variant="h6" fontWeight={500} textTransform={"capitalize"}>
        {t("shippingInfo")}
      </Typography>
      <Stack
        direction={"row"}
        mt={2}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <GlobalButton
          variant={"outlined"}
          btnText={"delivery"}
          startIcon={<LocalShippingOutlinedIcon />}
          styleProps={{
            width: "auto",
            boxShadow: "none",
          }}
        />

        <GlobalButton
          variant={"outlined"}
          btnText={!userAddress ? t("addAddress") : t("editAddress")}
          startIcon={!userAddress ? <AddIcon /> : <EditIcon />}
          handleClickBtn={() => {
            openAddressDialog.current.openDialog();
          }}
          styleProps={{
            width: "auto",
            boxShadow: "none",
          }}
        />
      </Stack>
      <Grid container rowSpacing={2} columnSpacing={1} my={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Label text={t("firstName")} required htmlFor="user-fname" />
          <InputField
            id={"user-fname"}
            required
            inputError={inputError.fname}
            helperText={inputError.fname && t("firstNameRequire")}
            placeholder={`${t("enter")} ${t("firstName")}`}
            type="text"
            name={"fname"}
            value={inputValues.fname}
            onChange={handleChangeInputs}
            readonly
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Label text={t("lastName")} required htmlFor="user-lname" />
          <InputField
            id={"user-lname"}
            required
            inputError={inputError.lname}
            helperText={inputError.lname && t("lastNameRequire")}
            placeholder={`${t("enter")} ${t("lastName")}`}
            type="text"
            name={"lname"}
            value={inputValues.lname}
            onChange={handleChangeInputs}
            readonly
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Label text={t("emailAddress")} required htmlFor="user-email" />
          <InputField
            id={"user-email"}
            required
            inputError={inputError.email || inputError.isValidEmail}
            helperText={
              inputError.email
                ? t("emailAddRequired")
                : inputError.isValidEmail
                ? t("invalidEmailFormat")
                : null
            }
            placeholder={`${t("enter")} ${t("emailAddress")}`}
            type="email"
            name={"email"}
            value={inputValues.email}
            onChange={handleChangeInputs}
            readonly
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Label text={t("contact")} required htmlFor="user-contact" />
          <InputField
            id={"user-contact"}
            required
            inputError={inputError.contact}
            helperText={inputError.contact && t("contactRequired")}
            placeholder={`${t("enter")} ${t("contactNumber")}`}
            type="number"
            name={"contact"}
            value={inputValues.contact}
            onChange={handleChangeInputs}
            readonly
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Label text={t("country")} required htmlFor="user-country" />
          <InputField
            id={"user-country"}
            required
            readonly
            value={inputValues.country}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Label text={t("state")} required htmlFor="user-state" />
          <CustomSelect
            id="user-state"
            name="state"
            value={inputValues.state}
            // onChange={handleStateChange}
            // selectError={inputError.state}
            // helperText={inputError.state && "State is required"}
            formStyleProps={{
              "& .MuiSelect-outlined": { padding: "8px !important" },
            }}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 300,
                  overflowY: "auto", // make sure the menu scrolls
                },
              },
            }}
          >
            <MenuItem value="">{t("selectState")}</MenuItem>
            {RomanianCities.map((stateObj) => (
              <MenuItem key={stateObj.state} value={stateObj.state}>
                {stateObj.state}
              </MenuItem>
            ))}
          </CustomSelect>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Label text={t("city")} required htmlFor="user-city" />
          <CustomSelect
            id="user-city"
            name="city"
            value={inputValues.city}
            // onChange={handleCityChange}
            // selectError={inputError.city}
            // helperText={inputError.city && "City is required"}
            // disabled={!inputValues.state}
            formStyleProps={{
              "& .MuiSelect-outlined": { padding: "8px !important" },
            }}
          >
            <MenuItem value="">{t("selectCity")}</MenuItem>
            {inputValues.state &&
              RomanianCities.find(
                (stateObj) => stateObj.state === inputValues.state
              )?.cities.map((city) => (
                <MenuItem key={city} value={city}>
                  {city}
                </MenuItem>
              ))}
          </CustomSelect>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Label text={t("zipCode")} required htmlFor="user-zip-code" />
          <InputField
            id={"user-zip-code"}
            required
            inputError={inputError.zipCode}
            helperText={inputError.zipCode && "Zip code is required"}
            placeholder={`${t("enter")} ${t("zipCode")}`}
            type="text"
            name={"zipCode"}
            value={inputValues.zipCode}
            onChange={handleChangeInputs}
            readonly
          />
        </Grid>
        <Grid size={12}>
          <Label text={t("address")} required htmlFor="user-address" />
          <InputField
            id={"user-address"}
            required
            inputError={inputError.address}
            helperText={inputError.address && t("addressRequired")}
            placeholder={`${t("enter")} ${t("fullAddress")}`}
            type="text"
            name={"address"}
            value={inputValues.address}
            onChange={handleChangeInputs}
            readonly
          />
        </Grid>
      </Grid>

      <FormControlLabel
        control={
          <Checkbox
            defaultChecked
            value={isAcceptPolicy}
            onChange={(e) => setisAcceptPolicy(e.target.checked)}
          />
        }
        label={t("checkoutTermsDesc")}
      />

      <AddEditAddressDialog ref={openAddEditAddressDialog} />
      <UserAllAddressDialog
        ref={openAddressDialog}
        openAddAddressDialog={() => {
          openAddEditAddressDialog.current.openDialog({
            type: "add",
            getData: () => {},
            data: null,
          });
        }}
      />
    </Box>
  );
};

export default ShippingInfo;
